import { StrictMode } from 'react';
import { MotionConfig } from 'motion/react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './app/App';
import { PageChoreography } from './app/PageChoreography';
import { ErrorBoundary, ToastProvider } from './primitives';
import './styles/globals.css';
import './styles/company-ui-tokens.css';
import './styles/zoe-kit.css';
import './styles/desk-foundation.css';
import { getAttribution } from './lib/analytics/attribution';

getAttribution();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('root element missing');

createRoot(rootEl).render(
  <StrictMode>
    <MotionConfig reducedMotion="user">
      <ErrorBoundary>
        <ToastProvider>
          <BrowserRouter
            future={{
              v7_startTransition: true,
              v7_relativeSplatPath: true,
            }}
          >
            <PageChoreography><App /></PageChoreography>
          </BrowserRouter>
        </ToastProvider>
      </ErrorBoundary>
    </MotionConfig>
  </StrictMode>
);
